// main component to display all the different pages
import { Switch, Route } from "react-router-dom";
import * as ROUTES from "../routes/routes";
import Sidebar from "../components/sidebar";
import MobileMenu from "../components/mobileMenu";
import { lazy, Suspense } from "react";
import Loader from "../components/utils/Loader";
import Home from "./home";

// lazy load pages for faster experience
const About = lazy(() => import("./about"));
const Blog = lazy(() => import("./blog"));
const Portfolio = lazy(() => import("./portfolio"));
const Resume = lazy(() => import("./resume"));
const Contact = lazy(() => import("./contact"));
const PortfolioSingle = lazy(() => import("./portfolioSingle"));
const BlogPost = lazy(() => import("./blogPost"));

export default function Main() {
	return (
		<div className="font-main leading-7 text-gray-600 dark:text-gray-300 dark:bg-gray-900">
			<Sidebar />
			<MobileMenu />
			<div className="lg:ml-72 px-5 sm:px-10 pb-10 lg:pb-0 min-h-screen relative">
				<Suspense fallback={<Loader />}>
					<Switch>
						<Route path={ROUTES.ABOUT} component={About} />
						<Route path={ROUTES.CONTACT} component={Contact} />
						<Route path={ROUTES.PORTFOLIO_SINGLE} component={PortfolioSingle} />
						<Route path={ROUTES.PORTFOLIO} component={Portfolio} />
						<Route path={ROUTES.RESUME} component={Resume} />
						<Route path={ROUTES.BLOG_SINGLE} component={BlogPost} />
						<Route path={ROUTES.BLOG} component={Blog} />
						<Route path={ROUTES.HOME} component={Home} />
					</Switch>
				</Suspense>
			</div>
		</div>
	);
}
